const { masterIndentStatusList, masterStatusGrouping } = require('pando-constants');
const StatusUtils = require('./base');

module.exports = new StatusUtils(masterIndentStatusList, masterStatusGrouping);
